import { ClientType } from "../models/client-type";
import { httpGet } from "./http-client";

const apiUrl = '/api/clienttypes';

export const getClientTypes = () => httpGet<ClientType[]>(apiUrl);
